module.exports = __webpack_public_path__ + "img/AFS-ALS.94e2b871.png";